(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalNomina', ConsortiumPersonalNomina);

    ConsortiumPersonalNomina.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalNomina($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-nominas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET'
            },
            'update': {
                method: 'PUT'
            },
            'save': {
                method: 'POST'
            }
        });
    }
})();
